import { Languages } from 'lucide-react'

import { useUiLocale } from '@/contexts/UiLocaleContext'
import { cn } from '@/lib/utils'

export function LanguageSwitcher({ className }) {
  const { locale, setLocale, t } = useUiLocale()

  return (
    <div
      className={cn('flex items-center gap-0.5 rounded-xl bg-muted/50 p-0.5', className)}
      role="group"
      aria-label={t('common.language')}
    >
      <button
        type="button"
        onClick={() => setLocale('en')}
        className={cn(
          'rounded-lg px-1.5 py-1 text-[10px] font-semibold transition-colors xl:px-2 xl:text-[11px]',
          locale === 'en'
            ? 'bg-card text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground',
        )}
        aria-pressed={locale === 'en'}
        title={t('common.english')}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLocale('ar')}
        className={cn(
          'rounded-lg px-1.5 py-1 text-[10px] font-semibold transition-colors xl:px-2 xl:text-[11px]',
          locale === 'ar'
            ? 'bg-card text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground',
        )}
        aria-pressed={locale === 'ar'}
        title={t('common.arabic')}
      >
        AR
      </button>
      <Languages className="ml-0.5 hidden h-3.5 w-3.5 text-muted-foreground 2xl:block" aria-hidden />
    </div>
  )
}
